import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { MAX_RETRY_ATTEMPTS, RETRY_DELAY_MS } from './utils'

export function RetryRoute() {
  const location = useLocation()
  const navigate = useNavigate()
  const [retryCount, setRetryCount] = useState(0)

  useEffect(() => {
    if (!location) {
      // If location is undefined, navigate to home or show error
      Sentry.captureException(new Error('Location is undefined in RetryRoute'), {
        tags: {
          component: 'RetryRoute',
          retryCount
        }
      })
      navigate('/')
      return
    }

    if (retryCount < MAX_RETRY_ATTEMPTS) {
      const timer = setTimeout(() => {
        setRetryCount((prev) => prev + 1)
        navigate(location)
        // Capture the route not found exception in Sentry
        Sentry.captureException(
          new Error(`Route not found: ${location.pathname}${location.search} - Attempt ${retryCount + 1}`),
          {
            tags: {
              route: location.pathname + location.search,
              attempt: retryCount + 1,
              maxRetries: MAX_RETRY_ATTEMPTS
            }
          }
        )
      }, RETRY_DELAY_MS)
      return () => clearTimeout(timer)
    }
  }, [retryCount, location, navigate])

  if (!location) {
    return (
      <div className='flex flex-col items-center justify-center h-screen'>
        <h1 className='text-2xl font-bold mb-4'>Error</h1>
        <p className='text-gray-600'>Unable to determine current location</p>
      </div>
    )
  }

  if (retryCount >= MAX_RETRY_ATTEMPTS) {
    return (
      <div className='flex flex-col items-center justify-center h-screen'>
        <h1 className='text-2xl font-bold mb-4'>404 - Page Not Found</h1>
        <p className='text-gray-600'>The page you're looking for doesn't exist.</p>
      </div>
    )
  }

  return <LoadingSpinner />
}
